import React from "react";
import emoji from "assets/images/gah/emoji.png";
import { motion } from "framer-motion/dist/framer-motion";

import { bounce_right_to_left_variants } from "shared/components/animations";
const LoserModal = ({ card }) => {
  return (
    <div className="loser-modal-container">
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={bounce_right_to_left_variants}
        className="loser-modal-inner"
      >
        <div className="border-div" />
        <img alt="" src={emoji} className="emoji-icon" />
        <h2 className="text">NICE TRY...</h2>

        <div className="modal-card-wrapper loser">
          <div className="title-div">
            <h2>{card.text}</h2>
          </div>

          <div className="gif-div" style={{}}>
            <img alt="" src={card.gif_url} />
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default LoserModal;
